import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { CompanyInsightsService, ExportPayload, ExportRequest } from 'src/app/_services/company-insights.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import * as _ from 'underscore';


@Component({
  selector: 'app-diversity-tab',
  templateUrl: './diversity-tab.component.html',
  styleUrls: ['./diversity-tab.component.scss']
})
export class DiversityTabComponent implements OnInit {

  constructor(private personSearchService: PersonSearchService, private location: Location, private companyinsightsService: CompanyInsightsService, private localStorageService: LocalStorageService,
    private filterDataHandlerService: FilterDataHandlerService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService, private aggService: AggregationService, private hashService: HashService) { }
  companyDetails: any;
  currentCompanyName: string;
  genderChart: any = [];
  totalFunctionResultCount: number = 0;
  dropDownMenu: any = [];
  selectedFunction: any;
  genderChartByFunction: any;
  startIndexForDiversity: number = 0;
  previousDiversityData: any = [];
  previousDiverityFunctions: any[] = [];
  diversityTable: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['key', 'doc_count', 'male', 'graph', 'female'];
  @ViewChild(MatSort, { static: true }) diversityTbSort: MatSort;
  aggregatescount: number = 50;
  isViewMore: boolean = true;
  alternatecompanyNames: any[] = [];
  diversitysubscription: Subscription;
  diversitydata: any;
  functionsname: any;
  genderemptystate: Boolean = false;
  functiongenderemptystate: Boolean = false;
  functionemptystate: Boolean = false;
  diversitySortData:any = [];

    /** start index in page */
    start: number = 0;
    /**End index in page */
    end: number = 6;
    /**Number of items on each of page */
    pageSize:number = 6;
    /**Current page number */
    currentPage: number = 1;
    /**Total items */
    totalCount = 0;
    diversitydataAI: any
    
      /** Subscription var */
  subscriptions: Array<Subscription> = [];
  companyinsightsFilter: any = {};

  insightsExportSubscription: Subscription = null;

  ngOnInit(): void {
    this.start = 0;
    this.end = 6;
    this.currentPage = 1;
    this.setCompanyDetails();
    this.fetchPageData();
    /**Fetch filter data after applying filters */
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.fetchPageData());
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.companyinsightsService.insightsExportRequestEvent.subscribe((requestData: ExportRequest) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
  }

  setCompanyDetails() {
    this.companyDetails = this.companyinsightsService.fetchCompanyData;
    this.currentCompanyName = this?.companyDetails?.name;
    this.alternatecompanyNames = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]) : [this.currentCompanyName];
  }

  fetchPageData() {
    this.getGenderChart();
    this.getDropDownMenu();
    this.getDiversityChart();
    this.personSearchService.setCompanyInsightsFilterAI(this.companyDetails);

  }


  getGenderChart() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "gender";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.totalFunctionResultCount = response.data.totalresultscount;
      this.genderemptystate = true;
      const data = response.data.aggregations.gender;
      const CharForSeniority = [];
      // let unknownGender = 0
      // if (data.length > 1) {
      //   unknownGender = this.totalFunctionResultCount - data[0].doc_count - data[1].doc_count;
      // } else if (data.length == 1) {
      //   unknownGender = this.totalFunctionResultCount - data[0].doc_count;
      // } else if (!data.length) {
      //   unknownGender = this.totalFunctionResultCount;
      // }
      // if (unknownGender) {
      //   data.push({
      //     key: "Not Known",
      //     doc_count: unknownGender,
      //   })
      // }

      data && data.forEach(x => {
        let dataObj = {
          label: `${x.key == 'male' ? 'Men' : 'Women'}`,
          value: x.doc_count,
          tooltext: `$label <br> Talent Count: $dataValue`
        }
        CharForSeniority.push(dataObj)
      })


      this.genderChart = {
        "type": "doughnut2d",
        "dataFormat": "json",
        "chart": {
          "paletteColors": "#ffd3a3, #95e1d3, #1B4E6B, #3934a5",
          "use3DLighting": "0",
          "decimals": "0",
          "yAxisNameFontColor": '#2C2C2C',
          "animateClockwise": "1",
          "enableSmartLabels":"1",
          "manageLabelOverflow":"1",
          "useEllipsesWhenOverflow":"1",
          "legendPosition": "bottom",
          "legendAllowDrag": "0",
          "theme": "fusion",
          "legendWidth": "500",
          "formatNumberScale": "0",
          "thousandSeparatorPosition": "2,3",
          "labelFont": "Poppins",
          "legendItemFont": "Poppins"
        },
        "data": CharForSeniority
      }
    });
  }


  getDropDownMenu() {

    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "current_function";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.dropDownMenu = response.data.aggregations['current_function'].map(x => x.key);
      this.selectedFunction = this.dropDownMenu[0];
      this.getGenderChartByFunction();
    });
  }

  filterselected(event) {
    this.selectedFunction = event.target.value;
    this.genderChartByFunction.data = [];
    this.getGenderChartByFunction();
  }

  getGenderChartByFunction() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "gender";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.functions = [this.selectedFunction];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      const totalCount = response.data.totalresultscount;
      this.functiongenderemptystate = true;
      const data = response.data.aggregations.gender;
      const ChartForGender = [];
      // let unknownGender = 0
      // if (data.length > 1) {
      //   unknownGender = totalCount - data[0].doc_count - data[1].doc_count;
      // } else if (data.length == 1) {
      //   unknownGender = totalCount - data[0].doc_count;
      // } else if (!data.length) {
      //   unknownGender = totalCount;
      // }
      // if (unknownGender) {
      //   data.push({
      //     key: "Not Known",
      //     doc_count: unknownGender,
      //   })
      // }

      data && data.forEach(x => {
        let dataObj = {
          label: `${x.key == 'male' ? 'Men' :  'Women' }`,
          value: x.doc_count,
          tooltext: `$label <br> Talent count: $dataValue`
        }
        ChartForGender.push(dataObj)
      })


      this.genderChartByFunction = {
        "type": "doughnut2d",
        "dataFormat": "json",
        "chart": {
          "paletteColors": "#ffd3a3, #95e1d3, #1B4E6B",
          "use3DLighting": "0",
          "decimals": "0",
          "yAxisNameFontColor": '#2C2C2C',
          "animateClockwise": "1",
          legendPosition: "bottom",
          "legendAllowDrag": "0",
          "theme": "fusion",
          legendWidth: "500",
          "formatNumberScale": "0",
          "thousandSeparatorPosition": "2,3",
          "labelFont": "Poppins",
          legendItemFont: "Poppins"
        },
        "data": ChartForGender
      }
    });
  }

  /**
   * Sort the array
   */
  manualSort() {
    this.reSortArray(this.diversityTbSort);
  }

  /**
   * Re-sort the array
   * @param {MatSort} sort
   */
  private reSortArray(sort: MatSort) {
    const data = this.diversitySortData;
    if (!sort || !sort.active || sort.direction === '') {
      this.diversitydata = data.slice(this.start, this.end);
      this.diversityTable = new MatTableDataSource(this.diversitydata);
      this.diversityTable.sort = this.diversityTbSort;
      return;
    }
     const tempData = this.diversitySortData.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'male': return this.compare(a.male, b.male, isAsc);
        case 'female': return this.compare(a.female, b.female, isAsc);
        default: return 0;
      }
    });
    
    this.diversitydata = tempData.slice(this.start, this.end);
    this.diversityTable = new MatTableDataSource(this.diversitydata);
    this.diversityTable.sort = this.diversityTbSort;   
  }

  private compare(a: number, b: number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }


  async getDiversityChart() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "current_function";
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe(async (response) => {
      const tempData = response.data.aggregations['current_function'];
      // const previousDiverityFunctionsLength = this.previousDiverityFunctions.length;
      // this.previousDiverityFunctions = this.previousDiverityFunctions.concat(tempData.slice(previousDiverityFunctionsLength, this.aggregatescount));
      // const functionArray = this.previousDiverityFunctions.map(x => x.key).slice(previousDiverityFunctionsLength, this.aggregatescount);
      // if(tempData.length < this.aggregatescount + 1) {
      //   this.isViewMore = false;
      // }
     // await this.processArrayWithForLoop(functionArray);

     this.totalCount = tempData.length;
    
      this.diversitySortData = tempData;
      this.diversitydata = tempData.slice(this.start, this.end);
      this.functionsname = _.pluck(this.diversitySortData, 'key');
      this.diversityTable = new MatTableDataSource(this.diversitydata);
      this.diversityTable.sort = this.diversityTbSort;
      this.functionemptystate = true;
      this.getfunctiondiversityratio();
      this.manualSort();

    });
  }
  
  private getPercentage(value: number, total: number) {
    return ((value/total)*100).toFixed(2);
  }

  getfunctiondiversityratio() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "current_function-gender";
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      const tempData = response.data.aggregations['current_function-gender'];
      this.diversitySortData.map(res=>{
        const gender = tempData.filter(x=>x.key.toLowerCase().trim() === res.key.toLowerCase().trim())[0];
        if(gender && gender.gender && gender.gender.length > 0) {
          const femalecount = gender.gender.filter(x=>x.key == "female") && gender.gender.filter(x=>x.key == "female").length > 0 ? gender.gender.filter(x=>x.key == "female")[0].doc_count: 0;
          const malecount = gender.gender.filter(x=>x.key == "male") && gender.gender.filter(x=>x.key == "male").length > 0 ? gender.gender.filter(x=>x.key == "male")[0].doc_count: 0;
          const totalgendercount = femalecount + malecount
          res.female = femalecount ? this.getdiversitypercentage(femalecount, totalgendercount): 0
          res.male = malecount ? this.getdiversitypercentage(malecount, totalgendercount): 0;
        } else {
          res.female = null;
          res.male = null;
        }
        return res;
      })
      this.getdiversitydataai(this.diversitySortData)
  })
}

getdiversitypercentage(value, doc_count) {
  return ((value / doc_count) * 100).toFixed(2);
}


  /**
 * Function set the start and end of aggreggate data according to page number
 * @param index page number in pagination
 */
  setPage(index: number){
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
    if(this.aggregatescount / this.pageSize <= index){
      this.aggregatescount = this.aggregatescount + this.pageSize;
      this.getDiversityChart();
    }
    else{
      this.manualSort();
    }
  }

  cleanCompanyName(companyName: string): string {
    return companyName.replace(/_/g, ' ');
  }

  /**
   * destroy subscriptions of filters
   */
   ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData 
   */
  shareDataForInsightsExport(requestData: ExportRequest) {
    if(requestData?.data?.currentTab !== 'diversity') return;

    // gender diversity chart config
    const genderDiversityChart = { renderAt: 'genderDiversityChart', dataSource: { ...this.genderChart } };
    genderDiversityChart['type'] = genderDiversityChart['dataSource']['type'];
    delete genderDiversityChart?.['dataSource']?.['type'];
    delete genderDiversityChart?.['dataSource']?.['width'];
    delete genderDiversityChart?.['dataSource']?.['chart']?.['width'];
    delete genderDiversityChart?.['dataSource']?.['height'];
    delete genderDiversityChart?.['dataSource']?.['chart']?.['height'];
    delete genderDiversityChart?.['dataSource']?.['chart']?.['renderAt'];

    // gender diversity by function chart config
    const genderDiversityByFunctionChart = { renderAt: 'genderDiversityByFunctionChart', dataSource: { ...this.genderChartByFunction } };
    genderDiversityByFunctionChart['type'] = genderDiversityByFunctionChart['dataSource']['type'];
    delete genderDiversityByFunctionChart?.['dataSource']?.['type'];
    delete genderDiversityByFunctionChart?.['dataSource']?.['width'];
    delete genderDiversityByFunctionChart?.['dataSource']?.['chart']?.['width'];
    delete genderDiversityByFunctionChart?.['dataSource']?.['height'];
    delete genderDiversityByFunctionChart?.['dataSource']?.['chart']?.['height'];
    delete genderDiversityByFunctionChart?.['dataSource']?.['chart']?.['renderAt'];

    const payloadForInsightsExport: ExportPayload = {
      tab: 'diversity',
      companydetails: this.companyDetails,
      totalresultcount: this.totalFunctionResultCount,
      chartdetails: [genderDiversityChart, genderDiversityByFunctionChart],
      selectedFunction: this.selectedFunction,
      diversityByFunction: this.diversitySortData
    }
    this.companyinsightsService.sendInsightsExportData(payloadForInsightsExport);
  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
  handelRedirection(type: string, key: string) {
    const additionalFilters = {};
    switch(type) {
      case 'functions': additionalFilters['mandatoryfunctions'] = [key]; break;
    }
    this.companyinsightsFilter['additionalFilters'] = additionalFilters;
    this.companyinsightsFilter['name'] = this?.companyDetails?.name;
    this.companyinsightsFilter['alternative_names'] = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]): [this.currentCompanyName];
    const uniqueHash = this.hashService.generateUniqueHash();
    this.talentInsightsReqHandlerService.setSessionDataForCompanyInsightsRedirection(uniqueHash, this.companyinsightsFilter);
    const requestObject = this.aggService.getRequestWithFilters();
    const url = `/person/search/listing?redirectSource=company-insights&${GeneralConstants.LS_KEYS.UNIQUE_HASH_COMPANY}=${uniqueHash}&keyword=${requestObject.booleanquery!= '*' ? requestObject.booleanquery: ''}`;    window.open(url, "_blank");
  }

  getdiversitydataai(data) {
    let diversitydata: any;
    diversitydata = data.map(x=>{
       let res: any ={};
       res['Function'] = x.key;
       res['Talent Count'] = x.doc_count;
       res['Men'] = x.male+'%';
       res['Women'] = x.female+'%';
       return res;
     })
     this.diversitydataAI = {
       functions: diversitydata
     }
     if(diversitydata.length == 0)
      this.diversitydataAI = null;
  }
}
